import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MicVolumeDataAccessModule } from "@youm-front/mic-volume/data-access";
import { MicVolumeUiModule } from "@youm-front/mic-volume/ui";
import Components from "./components";

@NgModule({
  declarations: [...Components],
  imports: [CommonModule, MicVolumeDataAccessModule, MicVolumeUiModule],
  exports: [...Components]
})
export class MicVolumeModule {}
